module.exports = __webpack_public_path__ + "static/media/introduce.8c14811c.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程锋锐F3E平板车/introduce.png
// module id = 701
// module chunks = 0